<template>
    <div style="position:relative;">
        <!-- >>> 'Treeview' (not really), Data Table ----------------------- -->
        <div ref="treeviewcontainerref" class="treeviewcontainer" :style="{ height: smallScreen ? '165px' : '330px'}">
            <v-data-table
                v-model="selected"
                :headers="headers"
                :items="get_flights_CrewDetails"
                hide-default-footer
                item-key="filterableName"
                :single-select="singleSelect"
                show-select
                class=""
                height="330"
                :sort-by="['order', 'genLastname']"
                :sort-desc="[false, false]"
                style="margin-bottom: 9px">

                <template v-slot:item.fdpHoursFormatted="{ item }">
                    <span v-if="item.fdpExtended === false">{{ item.fdpHoursFormatted }}</span>
                    <span v-if="item.fdpExtended === true">{{ item.fdpHoursFormatted }} <span style="font-size: 9px; color: #B3364D;">E</span></span>
                </template>

                <template v-slot:item.flyingToday="{ item }">
                    <v-progress-linear
                        v-if="get_flights_CrewDetails_HoursReport.length === 0"
                        color="blue-grey accent-4"
                        indeterminate
                        rounded
                        height="6"
                    ></v-progress-linear>
                    <v-chip
                        v-if="get_flights_CrewDetails_HoursReport.length > 0"
                        :color="getColorForFlyingToday(item.flyingToday)"
                        dark>
                        {{ item.flyingToday }}
                    </v-chip>
                </template>

                <template v-slot:item.proceeding="{ item }">
                    <v-progress-linear
                        v-if="get_flights_CrewDetails_HoursReport.length === 0"
                        color="blue-grey accent-4"
                        indeterminate
                        rounded
                        height="6"
                    ></v-progress-linear>
                    <v-chip
                        v-if="get_flights_CrewDetails_HoursReport.length > 0"
                        :color="getColorForProceeding(item.proceeding)"
                        dark>
                        {{ item.proceeding }}
                    </v-chip>
                </template>

                <template v-slot:item.hotel="{ item }">
                    <v-progress-linear
                        v-if="get_flights_CrewDetails_HoursReport.length === 0"
                        color="blue-grey accent-4"
                        indeterminate
                        rounded
                        height="6"
                    ></v-progress-linear>
                    <v-chip
                        v-if="get_flights_CrewDetails_HoursReport.length > 0"
                        :color="getColorForHotel(item.hotel)"
                        dark>
                        {{ item.hotel }}
                    </v-chip>
                </template>

                <template v-slot:item.error="{ item }">
                    <v-progress-linear
                        v-if="get_flights_CrewDetails_ErrorsOnResourceIsLoaded === false"
                        color="blue-grey accent-4"
                        indeterminate
                        rounded
                        height="6"
                    ></v-progress-linear>
                    <span
                        style="color: #aa0000;"
                        v-if="get_flights_CrewDetails_ErrorsOnResourceIsLoaded === true">
                        {{ item.error }}
                    </span>
                </template>
            </v-data-table>
        </div>
        <!-- <<< 'Treeview' (not really), Data Table ----------------------- -->


        <!-- >>> Phillips DragBar ------------------------------------------ -->
        <div
            ref="dragbarref"
            class="dragbar"
            :class="{hover: hoverDragbar}"
            @mouseover="hoverDragbar = true"
            @mouseleave="hoverDragbar = false"
        />
        <!-- <<< Phillips DragBar ------------------------------------------ -->
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import dayjs from 'dayjs';
    import { eventBus } from '../../../../../../main';


    export default {
        name : 'crewdetailslist',

        /* >>> *************************************************************** / /* Props */
        props : {
            value: [Array],
            editorMode: String,
            notSelectable: Boolean,
            changeExchange: String,
            aircraft: Object,
            smallScreen: Boolean,
            eventRecord: Object
        },
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /*******************************************************************
            * watch::selected
            *
            * Desc: Monitor/Watch ... 'selected'.
            * Note: Special Case: Unselect the seklected one
            *
            */
            selected() {

                if (this.selected[0] !== undefined) {
                    this.onDblClick_DataTableRow(this.selected[0])
                } else {
                    this.actn_reset_getCrewDetailsResourceBrief();
                }

            }, // eo function selected()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails', // Call 1: 'Get Crew Details'
                'get_flights_CrewDetails_HoursReport',
                'get_flights_CrewDetails_ErrorsOnResourceIsLoaded',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> DragBar ----------------------------
                hoverDragbar: false,
                treeviewcontainerref: null,
                dragbarref: null,
                dragbarCurrentYPosition: 0,
                // >>> CrewDetails ------------------------
                singleSelect: true,
                selected: [],
                headers: [
                    {
                        text: 'Name',
                        align: 'start',
                        sortable: false,
                        value: 'filterableName',
                    },
                    {
                        text: 'B:',
                        align: 'center',
                        sortable: false,
                        value: 'contractBaseStationCode',
                    },
                    {
                        text: 'Func:',
                        align: 'center',
                        sortable: false,
                        value: 'filterableFunc',
                    },
                    {
                        text: 'FT:',
                        align: 'center',
                        sortable: false,
                        value: 'flightHoursFormatted',
                    },
                    {
                        text: 'FDP:',
                        align: 'center',
                        sortable: false,
                        value: 'fdpHoursFormatted',
                    },
                    {
                        text: 'DT:',
                        align: 'center',
                        sortable: false,
                        value: 'dutyHoursFormatted',
                    },
                    {
                        text: 'CI time:',
                        align: 'center',
                        sortable: false,
                        value: 'CIDate',
                    },
                    {
                        text: 'CO time:',
                        align: 'center',
                        sortable: false,
                        value: 'CODate',
                    },
                    // >>> Boxes -----
                    {
                        text: 'FT:',
                        align: 'center',
                        sortable: false,
                        value: 'flyingToday',
                    },
                    {
                        text: 'PR:',
                        align: 'center',
                        sortable: false,
                        value :'proceeding',
                    },
                    {
                        text: 'HTL:',
                        align: 'center',
                        sortable: false,
                        value: 'hotel',
                    },
                    {
                        text: 'Validate-Errors(s):',
                        sortable: false,
                        value: 'error',
                    },
                ],
            };

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/CrewDetailsList.vue >>> mounted');
            eventBus.$on('resetcrewdetails', this.onReset_CrewDetails);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/CrewDetailsList.vue >>> mounted');
            me.onEmit_setDragAndDropListeners();

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/CrewDetailsList.vue >>> destroyed');
            eventBus.$off('resetcrewdetails', this.onReset_CrewDetails);

        }, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* methods */
        methods: {

            ...mapActions([
                'actn_reset_getCrewDetailsResourceBrief',
                'actn_call_getCrewDetailsResourceBrief',
            ]),


            /******************************************************************* 'Listeners'
            * Listeners:
            *******************************************************************/
			/*******************************************************************
			* onDblClick_DataTableRow()
			*
			* Desc: Event: dbclick:row => Sets ...
			* Note:
			*
			*/
			onDblClick_DataTableRow: function(resourceItem) {

				let me = this,
                    params = {
                        date: dayjs(this.eventRecord.data.startDate).format('YYYY-MM-DDT00:00:00'), // via prop (dateeventrecord)
                        idResource: resourceItem.id,
                        contractBaseStationCode: resourceItem.contractBaseStationCode
                    };


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/CrewDetailsList.vue >>> onDblClick_DataTableRow');
                me.actn_call_getCrewDetailsResourceBrief({ payload: params });

			}, // eo function onDblClick_DataTableRow()




            /******************************************************************* 'Listeners: Emit - Phillips DragBar'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_setDragAndDropListeners()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_setDragAndDropListeners: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/CrewDetailsList.vue >>> onEmit_setDragAndDropListeners');
                me.dragbarref = me.$refs.dragbarref;
                me.treeviewcontainerref = me.$refs.treeviewcontainerref;

                me.dragbarref.addEventListener("mousedown", function(e){
                    me.dragbarCurrentYPosition = e.y;

                    document.addEventListener("mousemove", me.onEmit_resizeList, false);
                }, false);

                document.addEventListener("mouseup", function(){
                    // me.hoverDragbar = false;
                    document.removeEventListener("mousemove", me.onEmit_resizeList, false);
                }, false);

            }, // eo function onEmit_setDragAndDropListeners()


            /*******************************************************************
            * onEmit_resizeList()
            *
            * Desc: Calculates the new height of the Treeview Container
            * Note:
            *
            */
            onEmit_resizeList: function(e) {

                let me = this,
                    dragbarNewPosition =  e.y - me.dragbarCurrentYPosition;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/CrewDetailsList.vue >>> onEmit_resizeList');
                if (e.preventDefault) { // prevent selection while draggin
                    e.preventDefault();
                }

                me.hoverDragbar = true;
                me.dragbarCurrentYPosition = e.y;
                me.treeviewcontainerref.style.maxHeight = (parseInt(getComputedStyle(me.treeviewcontainerref, '').maxHeight) + dragbarNewPosition) + "px";
                me.treeviewcontainerref.style.height = (parseInt(getComputedStyle(me.treeviewcontainerref, '').height) + dragbarNewPosition) + "px";

            }, // eo function onEmit_resizeList()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * getColorForFlyingToday()
            *
            * Desc:
            * Note:
            *
            */
            getColorForFlyingToday: function (flyingToday) {

                let me = this;


                // me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/CrewDetailsList.vue >>> getColorForFlyingToday');
                if (flyingToday === true) {
                    return '#A4C2A5';
                } else {
                    return 'rgba(255, 255, 255, 0)';
                }

            }, // eo function getColorForFlyingToday()


            /*******************************************************************
            * getColorForProceeding()
            *
            * Desc:
            * Note:
            *
            */
            getColorForProceeding: function (proceeding) {

                let me = this;


                // me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/CrewDetailsList.vue >>> getColorForProceeding');
                if (proceeding === true) {
                    return '#F9C22E';
                } else {
                    return 'rgba(255, 255, 255, 0)';
                }

            }, // eo function getColorForFlyingToday()


            /*******************************************************************
            * getColorForHotel()
            *
            * Desc:
            * Note:
            *
            */
            getColorForHotel: function (hotel) {

                let me = this;


                // me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/CrewDetailsList.vue >>> getColorForHotel');
                if (hotel === true) {
                    return '#A4C2A5';
                } else {
                    return 'rgba(255, 255, 255, 0)';
                }

            }, // eo function getColorForFlyingToday()


            /*******************************************************************
            * onReset_CrewDetails()
            *
            * Desc: Reset 'selectd'. (on Close Sheet)
            * Note:
            *
            */
            onReset_CrewDetails: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/CrewDetailsList.vue >>> onReset_CrewDetails');
                this.selected = [];

            }, // eo function onReset_CrewDetails()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .treeviewcontainer {
        position:sticky;
        top:0;
        overflow-y: auto;
    }

    .dragbar {
        position:absolute;
        bottom:0;
        width:100%;
        height:7px;
        background-color:#e5e5e8;
        text-align:center;
        cursor:ns-resize;
    }

    .hover {
        height: 13px;
    }


    .v-chip.v-size--default {
        border-radius: 16px;
        font-size: 14px;
        height: 20px;
    }



</style>

<style>
    .v-data-table table thead tr th {
        font-weight: 500 !important;
        font-size: 12px;
        padding: 0px 8px;
    }

    .v-data-table td {
        font-size: 13px;
        font-weight: 500 !important;
        height: 38px; /* 48 */
    }

    .v-data-table-header {
        background-color: #e5e5e8 !important;
    }

    .active {
        background-color: #ab3b7a !important;
        color: #ffffff !important;
    }
    .theme--light.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon {
        color: rgb(255 255 255 / 87%) !important;
    }



    .theme--light.v-data-table tbody tr.v-data-table__selected {
        background: #cb67a0 !important;
        color: #fff !important;
    }
</style>